export default "__VITE_ASSET__yd$8I9qR__"